import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DropdownModule } from 'primeng/dropdown';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ToastModule } from 'primeng/toast';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { MessageService } from 'primeng/api';
import { AlldocumentsViewPdfModalComponent } from './alldocuments-view-pdf-modal.component';
import { InvoiceTemplate1Component } from '../../shared/invoice-templates/template1/invoice-template1.component';
import { InvoiceTemplate2Component } from '../../shared/invoice-templates/template2/invoice-template2.component';
import { InvoiceTemplate3Component } from '../../shared/invoice-templates/template3/invoice-template3.component';
import { InvoiceDesktopComponent } from '../../shared/invoice-templates/invoice-desktop.component';
import { InvoiceTemplateService } from './invoice-template.service';
import { FormatNoteHtmlPipe } from '../../shared/invoice-templates/format-note-html.pipe';

@NgModule({
	declarations: [
		AlldocumentsViewPdfModalComponent,
		InvoiceTemplate1Component,
		InvoiceTemplate2Component,
		InvoiceTemplate3Component,
		InvoiceDesktopComponent,
		FormatNoteHtmlPipe
	],
	entryComponents: [InvoiceDesktopComponent],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		HttpClientModule,
		DialogModule,
		ButtonModule,
		ToolbarModule,
		SelectButtonModule,
		DropdownModule,
		SplitButtonModule,
		ToastModule,
		CheckboxModule,
		InputTextModule,
		TooltipModule
	],
	exports: [
		AlldocumentsViewPdfModalComponent,
		InvoiceDesktopComponent
	],
	providers: [
		MessageService,
		InvoiceTemplateService
	]
})
export class AlldocumentsViewPdfModalModule { }
